<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="用户管理">
      <a-button slot="extra" type="primary" @click="handleNewUser">新建用户</a-button>
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="用户姓名">
              <a-input
              v-model="searchP.fullname"
                  placeholder="请输入用户姓名或编码"
              ></a-input>
          </a-form-item>
          <a-form-item label="用户类型">
            <a-select v-model="searchP.usertype"  placeholder="">
                <a-select-option value="">
                全部
                </a-select-option>
                <a-select-option value="1">
                试用
                </a-select-option>
                <a-select-option value="2">
                正式
                </a-select-option>
                <a-select-option value="3">
                离职
                </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="所属组织">
              <a-input
              v-model="searchP.organizationid"
                  placeholder="请输入所属组织"
              ></a-input>
          </a-form-item>
         
          <a-form-item>
              <a-button
                  type="primary"
                  htmlType="submit"
                  :key="this.loading.key"

              >筛选</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    htmlType="submit"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="usercode" >
        <span slot="usertype" slot-scope="text">{{ ['', '试用', '正式', '离职'][text] }}</span>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'detailuser',
                    query: {
                        usercode: record.usercode
                    }
                }"
                >查看</router-link>
          </span>
          <span>
            <router-link
                    :to="{
                    path:'edituser',
                    query: {
                        usercode: record.usercode
                    }
                }"
                >编辑</router-link>
          </span>
          <span>
            <a-popconfirm  @confirm="() => onUserUp(record)" v-if="record.usertype == 1">
                <template slot="title">
                    <p>{{ '确认将' + record.fullname+ '转正？' }}</p>
                </template>
              <a>转正</a>
            </a-popconfirm>

            <a-popconfirm  @confirm="() => onUserGo(record)" v-if="record.usertype != 3">
                <template slot="title">
                    <p>{{ '确认将' + record.fullname+ '离职？' }}</p>
                </template>
              <a>离职</a>
            </a-popconfirm>
          </span>
         
        </div>
      </template>
    </a-table>

    <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
 
 
  </div>
</template>
<script>


const columns = [
    {
        title: '用户编码',
        dataIndex: 'usercode',
        align: 'center',
        width:120
    },
    {
        title: '用户手机号',
        dataIndex: 'tel',
        align: 'left',
        width: 120,
        ellipsises:true
    },
    
    {
        title: '用户姓名',
        dataIndex: 'fullname',
        align: 'left',
        width: 120,
    },
    {
        title: '所属组织',
        dataIndex: 'organizationids',
        align: 'left',
        width: 120,
    },
    {
        title: '用户类型',
        dataIndex: 'usertype',
        scopedSlots: { customRender: 'usertype' },
        align: 'center',
        width: 120,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }

];

const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP:{
                fullname:'',//用户姓名
                usertype:'',//用户类型
                organizationid:'',//所属组织
                total:0,
                pageSize:0,
                page:undefined,
            },
            tLoading:true,
        };
    },
    methods: {
        getUserList(){
            let c_params = {
                ...this.searchP,
                urlparams:false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "usercenter/selectUser",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handlePageChange(c_p){
            this.searchP.page = c_p;
            this.updateRoute();
        },
        updateRoute(){
            this.$router.push({
                query: {
                    organizationid:this.searchP.organizationid,
                    fullname:this.searchP.fullname,
                    usertype:this.searchP.usertype,
                    page:this.searchP.page
                }
            });
        },
        handleSearchReset(){
            this.searchP.page = 1;
            this.searchP.fullname = '';
            this.searchP.usertype = '';
            this.searchP.organizationid = '';

            this.updateRoute();
        },
        handleNewUser(){
            this.$router.push({
                path: "adduser",
                query: {usercode:''}
            });
        },
        handleSubmit(e){
            e.preventDefault();
            this.searchP.page = 1
            this.updateRoute()
        },
        //改成转正
        onUserUp(key) {
            let c_params = {
                usercode:key.usercode,
                usertype:2
            }
            this.$store.dispatch({
                type: "usercenter/changeUser",
                params: c_params
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getUserList();
                }
            });
        },
        //离职
        onUserGo(key){
            let c_params = {
                usercode:key.usercode,
                usertype:3
            }
            this.$store.dispatch({
                type: "usercenter/changeUser",
                params: c_params
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getUserList();
                }
            });
        }

    },

    components:{
    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    mounted(){
        let query = this.$route.query;
        this.searchP.fullname = query.fullname ? query.fullname : '';
        this.searchP.usertype = query.usertype ? query.usertype : '';
        this.searchP.organizationid = query.organizationid ? query.organizationid : '';
        this.searchP.page = query.page ? +query.page : 1;
        this.getUserList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
